// The stops the GATE, COMP and DUCKER time controls turn through, in a module of its own for
// the reason `comp-ratio.ts` is one: `vd.ts` bounds its encoders by the tables' ends and
// `translate.ts`, which is inside an import cycle, builds its field tables from them, both at
// module scope, and a binding read there is only reliable when the module it comes from
// imports nothing.
//
// Each table is written in its parameter's raw unit, the integer the unit writes at that
// stop, and exported in the plan's milliseconds.

// Attack, one table for GATE (`31`), COMP (`39`) and DUCKER (`262`): µs.
const ATTACK_RAW: readonly number[] = [
  92, 95, 97, 100, 103, 107, 110, 113, 117, 120, 124, 128, 131, 135, 140, 144, 148, 153, 157, 162, 167, 172, 177, 183,
  188, 194, 200, 206, 212, 219, 225, 232, 239, 247, 254, 262, 270, 278, 287, 295, 304, 313, 323, 333, 343, 353, 364,
  375, 387, 398, 410, 423, 436, 449, 463, 477, 491, 506, 522, 537, 554, 571, 588, 606, 624, 643, 663, 683, 704, 725,
  747, 770, 793, 818, 842, 868, 894, 922, 950, 979, 1008, 1039, 1071, 1103, 1137, 1171, 1207, 1244, 1281, 1320, 1360,
  1402, 1444, 1488, 1534, 1580, 1628, 1678, 1729, 1781, 1836, 1891, 1949, 2008, 2069, 2132, 2197, 2264, 2333, 2404,
  2477, 2552, 2630, 2710, 2792, 2877, 2965, 3055, 3148, 3243, 3342, 3444, 3548, 3656, 3767, 3882, 4000, 4122, 4247,
  4376, 4509, 4646, 4788, 4933, 5083, 5238, 5397, 5561, 5730, 5905, 6084, 6269, 6460, 6656, 6859, 7067, 7282, 7504,
  7732, 7967, 8209, 8459, 8716, 8981, 9254, 9536, 9826, 10120, 10430, 10750, 11080, 11410, 11760, 12120, 12490, 12870,
  13260, 13660, 14080, 14500, 14950, 15400, 15870, 16350, 16850, 17360, 17890, 18430, 18990, 19570, 20170, 20780, 21410,
  22060, 22730, 23420, 24140, 24870, 25630, 26410, 27210, 28040, 28890, 29770, 30670, 31610, 32570, 33560, 34580, 35630,
  36710, 37830, 38980, 40170, 41390, 42650, 43940, 45280, 46660, 48070, 49540, 51040, 52600, 54190, 55840, 57540, 59290,
  61090, 62950, 64870, 66840, 68870, 70970, 73120, 75350, 77640, 80000,
];

// GATE Hold (`32`): ms×100.
const HOLD_RAW: readonly number[] = [
  2, 4, 7, 9, 11, 14, 16, 18, 21, 23, 25, 27, 29, 31, 34, 36, 39, 41, 43, 45, 47, 49, 52, 54, 56, 58, 60, 62, 65, 67,
  69, 72, 75, 80, 84, 88, 93, 97, 102, 106, 110, 115, 119, 123, 128, 132, 136, 143, 149, 158, 167, 175, 184, 193, 201,
  210, 219, 228, 236, 245, 254, 262, 271, 284, 297, 314, 332, 349, 366, 384, 401, 419, 436, 453, 471, 488, 506, 523,
  540, 566, 592, 627, 661, 696, 731, 766, 801, 836, 870, 905, 940, 975, 1010, 1040, 1080, 1130, 1180, 1250, 1320, 1390,
  1460, 1530, 1600, 1670, 1740, 1810, 1880, 1950, 2020, 2090, 2160, 2260, 2360, 2500, 2640, 2780, 2920, 3060, 3200,
  3340, 3480, 3620, 3750, 3890, 4030, 4170, 4310, 4520, 4720, 5000, 5280, 5560, 5840, 6120, 6390, 6670, 6950, 7230,
  7510, 7790, 8070, 8340, 8620, 9030, 9450, 10000, 10600, 11100, 11700, 12200, 12800, 13300, 13900, 14500, 15000, 15600,
  16100, 16700, 17200, 18100, 18900, 20000, 21100, 22200, 23300, 24500, 25600, 26700, 27800, 28900, 30000, 31100, 32300,
  33400, 34500, 36100, 37800, 40000, 42200, 44500, 46700, 48900, 51100, 53400, 55600, 57800, 60100, 62300, 64500, 66700,
  69000, 72300, 75600, 80000, 84500, 88900, 93400, 97800, 102000, 107000, 111000, 116000, 120000, 125000, 129000,
  133000, 138000, 145000, 151000, 160000, 169000, 178000, 187000, 196000,
];

// One table for GATE Decay (`33`) and COMP Release (`40`): ms×10.
const RELEASE_RAW: readonly number[] = [
  93, 95, 97, 98, 100, 102, 103, 105, 107, 109, 111, 112, 114, 116, 118, 120, 122, 125, 127, 129, 131, 133, 136, 138,
  140, 143, 145, 148, 150, 153, 155, 158, 161, 163, 166, 169, 172, 175, 178, 181, 184, 187, 190, 194, 197, 200, 204,
  207, 211, 214, 218, 222, 226, 229, 233, 237, 241, 245, 250, 254, 258, 263, 267, 272, 276, 281, 286, 291, 296, 301,
  306, 311, 317, 322, 327, 333, 339, 344, 350, 356, 362, 369, 375, 381, 388, 394, 401, 408, 415, 422, 429, 437, 444,
  452, 459, 467, 475, 483, 492, 500, 509, 517, 526, 535, 544, 553, 563, 573, 582, 592, 602, 613, 623, 634, 645, 656,
  667, 678, 690, 701, 713, 726, 738, 751, 763, 776, 790, 803, 817, 831, 845, 859, 874, 889, 904, 920, 935, 951, 967,
  984, 1001, 1018, 1035, 1053, 1071, 1089, 1108, 1127, 1146, 1165, 1185, 1206, 1226, 1247, 1268, 1290, 1312, 1334, 1357,
  1380, 1404, 1428, 1452, 1477, 1502, 1528, 1554, 1580, 1607, 1635, 1663, 1691, 1720, 1749, 1779, 1809, 1840, 1872,
  1904, 1936, 1969, 2003, 2037, 2072, 2107, 2143, 2180, 2217, 2255, 2293, 2332, 2372, 2412, 2454, 2495, 2538, 2581,
  2625, 2670, 2716, 2762, 2809, 2857, 2906, 2955, 3006, 3057, 3109, 3162, 3216, 3271, 3327, 3384, 3441, 3500, 3560,
  3621, 3682, 3745, 3809, 3874, 3940, 4007, 4076, 4145, 4216, 4288, 4361, 4435, 4511, 4588, 4666, 4746, 4827, 4909,
  4993, 5078, 5165, 5253, 5342, 5434, 5526, 5621, 5716, 5814, 5913, 6014, 6117, 6221, 6327, 6435, 6545, 6656, 6770,
  6885, 7003, 7122, 7244, 7367, 7493, 7621, 7751, 7883, 8018, 8154, 8293, 8435, 8579, 8725, 8874, 9025, 9179, 9336,
  9495, 9657, 9822, 9990,
];

// DUCKER Decay (`263`): ms×10.
const DUCKER_DECAY_RAW: readonly number[] = [
  13, 14, 15, 16, 17, 18, 19, 20, 22, 24, 26, 28, 30, 33, 36, 39, 42, 45, 48, 51, 54, 57, 60, 64, 68, 72, 76, 80, 85,
  90, 95, 100, 110, 120, 130, 140, 150, 160, 170, 180, 190, 200, 220, 240, 260, 280, 300, 330, 360, 390, 420, 450, 480,
  510, 540, 570, 600, 640, 680, 720, 760, 800, 850, 900, 950, 1000, 1100, 1200, 1300, 1400, 1500, 1600, 1700, 1800,
  1900, 2000, 2200, 2400, 2600, 2800, 3000, 3300, 3600, 3900, 4200, 4500, 4800, 5100, 5400, 5700, 6000, 6400, 6800,
  7200, 7600, 8000, 8500, 9000, 9500, 10000, 11000, 12000, 13000, 14000, 15000, 16000, 17000, 18000, 19000, 20000,
  22000, 24000, 26000, 28000, 30000, 33000, 36000, 39000, 42000, 45000, 48000, 50000,
];

const inMs = (raw: readonly number[], perMs: number): readonly number[] => raw.map((r) => r / perMs);

/** The narrowest spacing between two neighbouring stops, in ms. */
const finestMs = (raw: readonly number[], perMs: number): number =>
  Math.min(...raw.slice(1).map((r, i) => r - raw[i])) / perMs;

/** Attack stops, in ms: GATE, COMP and DUCKER alike. */
export const DYN_ATTACK_STOPS_MS: readonly number[] = inMs(ATTACK_RAW, 1000);
export const DYN_ATTACK_FINEST_MS = finestMs(ATTACK_RAW, 1000);

/** GATE Hold stops, in ms. */
export const DYN_HOLD_STOPS_MS: readonly number[] = inMs(HOLD_RAW, 100);
export const DYN_HOLD_FINEST_MS = finestMs(HOLD_RAW, 100);

/** GATE Decay and COMP Release stops, in ms. */
export const DYN_RELEASE_STOPS_MS: readonly number[] = inMs(RELEASE_RAW, 10);
export const DYN_RELEASE_FINEST_MS = finestMs(RELEASE_RAW, 10);

/** DUCKER Decay stops, in ms. */
export const DUCKER_DECAY_STOPS_MS: readonly number[] = inMs(DUCKER_DECAY_RAW, 10);
export const DUCKER_DECAY_FINEST_MS = finestMs(DUCKER_DECAY_RAW, 10);
